import type { CopilotProposalId } from "@repo/app-types/entities/copilotProposal";
import type { SignalId } from "@repo/app-types/entities/signal";
import type { To } from "react-router";
import { appPaths } from "../../../app/appPaths.js";

export const SIGNAL_PROPOSAL_QUERY_PARAM = "proposalId";

/**
 * The editor location that pre-fills a copilot proposal. A `create_signal`
 * proposal has no saved signal, so it opens the new-signal editor.
 */
export function buildSignalProposalEditLocation(props: {
  signalId: SignalId | undefined;
  proposalId: CopilotProposalId;
}) {
  const searchParams = new URLSearchParams({
    [SIGNAL_PROPOSAL_QUERY_PARAM]: props.proposalId,
  });
  return {
    pathname: props.signalId
      ? appPaths.settingsSignal.build({ signalId: props.signalId })
      : appPaths.settingsNewSignal.build(),
    search: `?${searchParams.toString()}`,
  } satisfies To;
}
